export type AccessDeniedReason = 'forbidden' | 'permission_denied';

type Listener = (id: string, reason: AccessDeniedReason) => void;
const listeners = new Set<Listener>();

export function onDocAccessDenied(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function fireDocAccessDenied(id: string, reason: AccessDeniedReason): void {
  listeners.forEach((fn) => fn(id, reason));
}
